import { CATEGORY_MODEL_CLASS_NAME } from 'models/daos/category/constants'
import { TAG_MODEL_CLASS_NAME } from 'models/daos/tag/constants'
import { USER_MODEL_CLASS_NAME } from 'models/daos/user/constants'

const MOTIVATION_MODEL_CLASS_NAME = 'Motivation'

const MOTIVATION_MODEL_KEY = {
  ID: 'id',
  CLASS_NAME: 'className',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',
  TITLE: 'title',
  DESCRIPTION: 'description',
  IMG: 'img',
  SHARE_IMG: 'shareImg',
  KEY: 'key',
  SLUG: 'slug',
  PUBLISHED_AT: 'publishedAt',
  FEATURED_AT: 'featuredAt',
  VIDEO: 'video',
  VIDEO_TYPE: 'videoType',
  COMMENT_COUNT: 'commentCount',
  CATEGORIES: 'categories',
  COMMENTS: 'comments',
  RECOMMENDED: 'recommended',
  TAGS: 'tags',
  USER: 'user'
}

const MOTIVATION_MODEL_KEY_POINTER = MOTIVATION_MODEL_KEY.SLUG

const MOTIVATION_MODEL_VALIDATOR = {
  [MOTIVATION_MODEL_KEY.TITLE]: [
    10,
    60
  ],
  [MOTIVATION_MODEL_KEY.DESCRIPTION]: [
    10,
    1024
  ],
  [MOTIVATION_MODEL_KEY.TAGS]: [
    3,
    20
  ],
  [MOTIVATION_MODEL_KEY.KEY]: 8,
  [MOTIVATION_MODEL_KEY.SLUG]: [
    3,
    12
  ],
  [MOTIVATION_MODEL_KEY.CATEGORIES]: [
    0,
    3
  ],
  [MOTIVATION_MODEL_KEY.RECOMMENDED]: [
    0,
    10
  ]
}

const MOTIVATION_MODEL_PLACEHOLDER = {
  [MOTIVATION_MODEL_KEY.TITLE]: 'The Motivation Title',
  [MOTIVATION_MODEL_KEY.DESCRIPTION]: 'This motivation post will get you pumped!',
  [MOTIVATION_MODEL_KEY.IMG]: 'https//cdn.gymaholic.co/posts/21-how-to-become-happy/1-how-to-become-happy.jpg',
  [MOTIVATION_MODEL_KEY.SHARE_IMG]: 'https//cdn.gymaholic.co/posts/21-how-to-become-happy/share-how-to-become-happy-1.jpg',
  [MOTIVATION_MODEL_KEY.SLUG]: 'how-to-become-happy',
  [MOTIVATION_MODEL_KEY.KEY]: '111963527349',
  [MOTIVATION_MODEL_KEY.TAGS]: 'Motivation, Happiness, Joy',
  [MOTIVATION_MODEL_KEY.CATEGORIES]: 'memes, videos',
  [MOTIVATION_MODEL_KEY.RECOMMENDED]: '10, 5, (motivationId)',
  [MOTIVATION_MODEL_KEY.PUBLISHED_AT]: false,
  [MOTIVATION_MODEL_KEY.FEATURED_AT]: false,
  [MOTIVATION_MODEL_KEY.VIDEO]: 'https//cdn.gymaholic.co/posts/21-how-to-become-happy/share-how-to-become-happy-1.mp4'
}

/**
 * A mapping of property key to className.
 * @type {Object}
 */
const MOTIVATION_MODEL_ASSOCIATION = {
  [MOTIVATION_MODEL_KEY.CATEGORIES]: CATEGORY_MODEL_CLASS_NAME,
  [MOTIVATION_MODEL_KEY.COMMENTS]: 'Comment',
  [MOTIVATION_MODEL_KEY.RECOMMENDED]: MOTIVATION_MODEL_CLASS_NAME,
  [MOTIVATION_MODEL_KEY.TAGS]: TAG_MODEL_CLASS_NAME,
  [MOTIVATION_MODEL_KEY.USER]: USER_MODEL_CLASS_NAME
}

/**
 * A list of association keys loaded separately.
 * @type {String[]}
 */
const MOTIVATION_MODEL_ASSOCIATIONS_ISOLATE = [
  MOTIVATION_MODEL_KEY.COMMENTS
]
const MOTIVATION_MODEL_VIDEO_TYPE = {
  YOUTUBE: 'youtube',
  TUMBLR: 'tumblr',
  HTML5: 'html5',
  UNKNOWN: 'unknown'
}

export {
  MOTIVATION_MODEL_CLASS_NAME,
  MOTIVATION_MODEL_KEY,
  MOTIVATION_MODEL_KEY_POINTER,
  MOTIVATION_MODEL_VALIDATOR,
  MOTIVATION_MODEL_PLACEHOLDER,
  MOTIVATION_MODEL_ASSOCIATION,
  MOTIVATION_MODEL_ASSOCIATIONS_ISOLATE,
  MOTIVATION_MODEL_VIDEO_TYPE
}
